import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Fabric, Pivot, PivotItem } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { Helmet } from 'react-helmet';
import { authSelector } from 'store/auth/selector';
import { ArbeitszeitView } from 'reports/arbeitszeit/ArbeitszeitView';
import { BmdView } from './BmdView/BmdView';
import { BetreuerView } from './BetreuerView/BetreuerView';
import { BetreuerzuweisungView } from './Betreuerzuweisung/Betreuerzuweisung';
import { LookupsView } from './LookupsView/LookupsView';
import { MailingView } from './MailingView/MailingView';

const styles = mergeStyleSets({
    container: {
        width: '100%',
        height: '100%',
    },
    itemWrapper: {
        height: 'calc(100vh - 75px)',
    },
});

const pivotStyles = {
    itemContainer: {
        height: 'calc(100vh - 120px)',
    },
};

interface ExtrasViewParams {
    page?: string;
}

interface ExtrasViewProps {
    page?: string;
}

export const ExtrasView: React.FC<ExtrasViewProps> = () => {
    const auth = useSelector(authSelector);
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);
    const history = useHistory();
    const { page } = useParams<ExtrasViewParams>();

    if (!page) {
        history.push('/extras/arbeitszeit');
    }

    if (!lookupsLoadingFinished) {
        return null;
    }

    return (
        <Fabric className={styles.container}>
            <Helmet>
                <title>Extras</title>
            </Helmet>
            <Pivot
                styles={pivotStyles}
                selectedKey={page}
                onLinkClick={(item) => {
                    history.push('/extras/' + (item?.props.itemKey || ''));
                }}
            >
                <PivotItem itemKey="arbeitszeit" headerText="Arbeitszeit" className={styles.itemWrapper}>
                    <ArbeitszeitView />
                </PivotItem>
                <PivotItem itemKey="betreuer" headerText="Betreuer" className={styles.itemWrapper}>
                    <BetreuerView />
                </PivotItem>
                {auth.rolle === 'GF' && (
                    <PivotItem itemKey="bmd" headerText="BMD" className={styles.itemWrapper}>
                        <BmdView />
                    </PivotItem>
                )}
                {auth.rolle === 'GF' && (
                    <PivotItem
                        itemKey="betreuerzuweisung"
                        headerText="Betreuerzuweisung"
                        className={styles.itemWrapper}
                    >
                        <BetreuerzuweisungView />
                    </PivotItem>
                )}
                {auth.rolle !== 'AD' && auth.rolle !== 'EX' && (
                    <PivotItem itemKey="mailing" headerText="Mailing" className={styles.itemWrapper}>
                        <MailingView />
                    </PivotItem>
                )}
                {auth.rolle !== 'AD' && auth.rolle !== 'EX' && (
                    <PivotItem itemKey="wertetabellen" headerText="Wertetabellen" className={styles.itemWrapper}>
                        <LookupsView />
                    </PivotItem>
                )}
            </Pivot>
        </Fabric>
    );
};
